export const sources={webp:"__VITE_ASSET__CDD9Oi3Y__ 60w"};export const img={src:"__VITE_ASSET__B_iUUM84__",w:60,h:60};export default{sources:sources,img:img};